import api from "../axios";
import {
  RoamingApiStruct,
  RoamingCountriesByZoneStruct,
} from "@/struct/RoaminStruct";

export const GetCountriesByZone = async (zone_uuid = "" as string) => {
  return await api
    .post<RoamingApiStruct<RoamingCountriesByZoneStruct>>(
      "/api/public/roaming/countries-by-zone",
      { zone_uuid }
    )
    .then((res) => {
      if (res.data.status) return res.data.data;
      else throw res.data;
    })
    .catch((err) => {
      throw err;
    });
};
